var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasketIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4848 5.39704C14.3411 5.30147 14.1725 5.25049 14 5.25049C13.8275 5.25049 13.6589 5.30147 13.5153 5.39704L8.48575 8.75004H1.75V10.5H3.6155L5.25875 21.9975C5.28826 22.2063 5.39215 22.3973 5.55131 22.5356C5.71046 22.6739 5.91418 22.75 6.125 22.75H21.875C22.0858 22.75 22.2895 22.6739 22.4487 22.5356C22.6078 22.3973 22.7117 22.2063 22.7412 21.9975L24.3845 10.5H26.25V8.75004H19.5142L14.4848 5.39704ZM14 7.17679L16.3608 8.75004H11.6375L14 7.17679ZM9.625 18.375V13.125H11.375V18.375H9.625ZM13.125 18.375V13.125H14.875V18.375H13.125ZM16.625 13.125V18.375H18.375V13.125H16.625Z",
    fill: "#F7F7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketIcon);
export default __webpack_public_path__ + "static/media/basket-icon.f170766f8a7994d8564d0d71603c15e6.svg";
export { ForwardRef as ReactComponent };